<template>
    <div>
        <h1 class="display-heading">{{pageTitle}}</h1>
        <div v-if="!showForm" class="card mb-5">
            <div class="card-body">
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-right">Identity type</label>
                    <div class="col-md-4">
                        <select name="searchIdentityType" data-vv-validate-on="blur|input" data-vv-as="identification type"
                            v-validate="identificationTypeValidation" v-model="searchIdentityType" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('searchIdentityType')
                        }">
                            <option :value="null">Please Select</option>
                            <option v-for="(identificationType, index) in identificationTypes" :key="index"
                                :value="identificationType.value">
                                {{identificationType.text}}
                            </option>
                        </select>
                        <div v-show="validationErrors.has('searchIdentityType')" class="invalid-feedback">
                            {{ validationErrors.first('searchIdentityType') }}
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-right">Identity Number</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" name="ic" v-mask="searchIdentityType === 1 ? '######-##-####' : null" placeholder="E.g. 123456-78-9123" v-model="searchIdentityNumber">
                        <!-- <input v-else type="text" class="form-control" name="ic" placeholder="E.g. 123456-78-9123" v-model="searchIdentityNumber"> -->
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-4 offset-md-3">
                        <button @click="checkDetails" class="btn btn-primary btn-primary-insv">Search / Add User</button>
                    </div>
                </div>
            </div>
        </div>

        <form v-if="showForm" data-vv-scope="employee-tier" @submit.prevent="validateTierForm">
            <div v-if="!isNewUser" class="alert alert-success" role="alert">
                User with entered identity card number "{{ form.in }}" has an existing user account on {{ companyName }}.<br>
                Hence his/her personal details is not editable.
            </div>
            <div class="row">
                <div class="form-group col-md-6">
                    <label>Employee Name</label>
                    <!-- <select v-if="isAddEmployeeTier" placeholder="Employee Name" name="employeeName" v-model="form.ui"
                        data-vv-as="employee name" data-vv-validate-on="change"
                        v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('employee-tier.employeeName')
                    }">
                        <option :value="null">Choose...</option>
                        <option v-for="(employee, index) in employees" :key="index" :value="employee.UserId">
                            {{employee.FullName}}
                        </option>
                    </select> -->
                    <input type="text" placeholder="Employee Full Name" name="employeeFullName" v-model="form.fn"
                        data-vv-as="employee name" data-vv-validate-on="change"
                        v-validate="'required'" :disabled="!isNewUser" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('employee-tier.employeeFullName')
                    }">
                    <div v-show="validationErrors.has('employee-tier.employeeFullName')"
                        class="invalid-feedback">
                        {{ validationErrors.first('employee-tier.employeeFullName') }}
                    </div>
                </div>
                <div class="form-group col-md-3">
                    <label>Employee Identity Type</label>
                    <select placeholder="Employee Identity Type" name="employeeIdentityType" v-model="form.it"
                        data-vv-as="employee identity type" data-vv-validate-on="change"
                        v-validate="identificationTypeValidation" :disabled="!isNewUser" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('employee-tier.employeeIdentityType')
                    }">
                        <!-- <option :value="null">Please Select</option> -->
                        <option v-for="(identificationType, index) in identificationTypes" :key="index"
                            :value="identificationType.value">
                            {{identificationType.text}}
                        </option>
                    </select>
                    <div v-show="validationErrors.has('employee-tier.employeeIdentityType')" class="invalid-feedback">
                        {{ validationErrors.first('employee-tier.employeeIdentityType') }}
                    </div>
                </div>
                <div class="form-group col-md-3">
                    <label>Employee Identity Number</label>
                    <input type="text" :placeholder="form.it === 1 ? '######-##-####' : 'Employee Identity Number'" name="employeeIdentityNumber" v-model="form.in"
                        data-vv-as="employee identity number" data-vv-validate-on="change"
                        v-validate="'required'" v-mask="form.it === 1 ? '######-##-####' : null" :disabled="!isNewUser" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('employee-tier.employeeIdentityNumber')
                    }">
                    <div v-show="validationErrors.has('employee-tier.employeeIdentityNumber')"
                        class="invalid-feedback">
                        {{ validationErrors.first('employee-tier.employeeIdentityNumber') }}
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <label>Birth date</label>
                    <input type="text" ref="employeeDob" placeholder="DD/MM/YYYY" name="employeeDob" v-model="form.dob"
                        data-vv-as="birth date" data-vv-validate-on="blur" v-mask="'##/##/####'" :disabled="!isNewUser"
                        v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('employee-tier.employeeDob')
                        }">
                    <div v-show="validationErrors.has('employee-tier.employeeDob')"
                        class="invalid-feedback">
                        {{ validationErrors.first('employee-tier.employeeDob') }}
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <label>Email</label>
                    <input type="text" placeholder="Employee Email" name="employeeEmail" v-model="form.e"
                        data-vv-as="employee email" data-vv-validate-on="change"
                        v-validate="'email'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('employee-tier.employeeEmail')
                    }">
                    <div v-show="validationErrors.has('employee-tier.employeeEmail')"
                        class="invalid-feedback">
                        {{ validationErrors.first('employee-tier.employeeEmail') }}
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <label>Phone Number</label>
                    <input type="text" placeholder="Employee Phone Number" name="employeePhoneNumber" v-model="form.pn" class="form-control" :disabled="!isNewUser">
                </div>
                <div class="form-group col-md-4">
                    <label>Gender</label>
                    <select :disabled="!isNewUser" name="gender" v-model="form.g"
                        data-vv-as="gender" data-vv-validate-on="blur|input"
                        v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('employee-tier.gender')
                    }">
                        <option :value="null" disabled hidden>Please Select...</option>
                        <option v-for="(gender, index) in genders" :key="index"
                            :value="gender.value">
                            {{gender.text}}
                        </option>
                    </select>
                    <div v-show="validationErrors.has('employee-tier.gender')" class="invalid-feedback">
                        {{ validationErrors.first('employee-tier.gender') }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6">
                    <label>Employee Number</label>
                    <input type="text" placeholder="Employee Number" name="employeeNumber" v-model="form.en" class="form-control">
                </div>
                <div class="form-group col-md-6">
                    <label>Department</label>
                    <input type="text" placeholder="Department" name="department" v-model="form.d" class="form-control">
                </div>
                <div class="form-group col-md-4">
                    <label>Tier Name</label>
                    <select placeholder="Tier Name" name="tierName" v-model="form.ti"
                        data-vv-as="tier name" data-vv-validate-on="blur"
                        v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('employee-tier.tierName')
                    }">
                        <option :value="null">Choose...</option>
                        <option v-for="(tier, index) in tiers" :key="index" :value="tier.TierId">
                            {{tier.TierName}}
                        </option>
                    </select>
                    <div v-show="validationErrors.has('employee-tier.tierName')"
                        class="invalid-feedback">
                        {{ validationErrors.first('employee-tier.tierName') }}
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <label>Join Date</label>
                    <input type="text" placeholder="DD/MM/YYYY" name="joinDate" v-model="form.jd" class="form-control" v-mask="'##/##/####'">
                </div>
                <div class="form-group col-md-4">
                    <template v-if="showDeactivationDate">
                        <label>Deactivation Date</label>
                        <input type="text" placeholder="DD/MM/YYYY" name="deactivationDate" v-model="form.dd" class="form-control" v-mask="'##/##/####'">
                    </template>
                    <button v-else class="btn btn-danger btn-danger-insv mr-2 mb-2 mt-32" type="button" style="margin-top:32px" @click="deactivationAlert">Deactivate Employee</button>
                </div>
            </div>

            <div class="mb-3">
                <div class="card">
                    <div class="card-header">Dependent List</div>
                    <div class="card-body">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Identity Number</th>
                                    <th>Relationship</th>
                                    <th>Gender</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dependent, index) in form.dl" :key="index">
                                    <th scope="row">{{index + 1}}</th>
                                    <td>{{dependent.fn}}</td>
                                    <td>{{dependent.in}}</td>
                                    <td>{{relationshipTypes.find(r => r.value == dependent.r).text}}</td>
                                    <td>
                                        <span v-if="dependent.g===1">
                                            Male
                                        </span>
                                        <span v-else-if="dependent.g===2">
                                            Female
                                        </span>
                                        <span v-else>
                                            Unspecified
                                        </span>
                                    </td>
                                    <td>
                                        <button class="btn btn-primary btn-primary-insv mr-2 mb-2" type="button" @click="dependentDetail(index)">Details</button>
                                        <button class="btn btn-danger mr-2 mb-2" type="button" @click="removeDependent(index)">Remove</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button class="btn btn-primary btn-primary-insv mr-2 mb-2" type="button" @click="dependentDetail(null)">Add Dependent</button>
                    </div>
                </div>
            </div>

            <p v-if="shouldShowSubmitMessage"
                :class="{
                    'text-danger': submitHasError
                }" v-html="submitMessage">
            </p>
            <div>
                <button v-if="!isAddEmployeeTier && allowDelete" class="btn btn-danger btn-danger-insv mr-2 mb-2" type="button" @click="deleteEmployeeAlert" :disabled="isSaving">Delete Employee</button>
                <button class="btn btn-primary btn-primary-insv mr-2 mb-2" type="button" @click="saveChanges" :disabled="isSaving">Save</button>
                <div>
                    <router-link class="btn btn-secondary mb-2" :to="{'name': 'employee-tier-list'}">Back to List</router-link>
                </div>
            </div>
        </form>

        <popup-modal ref="popupModalDependentDetail" :hasCloseButton="false" title="Dependent Details">
            <template slot="content">
                <form data-vv-scope="dependent" @submit.prevent="validateTierForm">
                    <div class="form-group">
                        <label>Full Name</label>
                        <input type="text" placeholder="Full Name" name="fullName" v-model="currentDependent.fn"
                            data-vv-as="full name" data-vv-validate-on="blur" :disabled="currentDependent.edi !== null"
                            v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('dependent.fullName')
                            }">
                        <div v-show="validationErrors.has('dependent.fullName')"
                            class="invalid-feedback">
                            {{ validationErrors.first('dependent.fullName') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Identity Type</label>
                        <select name="identityType" v-model="currentDependent.it"
                            data-vv-as="identification type" data-vv-validate-on="blur" :disabled="currentDependent.edi !== null"
                            v-validate="identificationTypeValidation" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('dependent.identityType')
                            }">
                            <option :value="null" disabled hidden>Please Select...</option>
                            <option v-for="(identificationType, index) in identificationTypes" :key="index"
                                :value="identificationType.value">
                                {{identificationType.text}}
                            </option>
                        </select>
                        <div v-show="validationErrors.has('dependent.identityType')" class="invalid-feedback">
                            {{ validationErrors.first('dependent.identityType') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Identity Number</label>
                        <input type="text" :placeholder="currentDependent.it === 1 ? '######-##-####' : 'Identity Number'" name="identityNumber" v-model="currentDependent.in"
                            data-vv-as="Identity Number" data-vv-validate-on="blur" v-mask="currentDependent.it === 1 ? '######-##-####' : null" :disabled="currentDependent.edi !== null"
                            v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('dependent.identityNumber')
                            }">
                        <div v-show="validationErrors.has('dependent.identityNumber')"
                            class="invalid-feedback">
                            {{ validationErrors.first('dependent.identityNumber') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Birth date</label>
                        <input type="text" ref="dob" placeholder="DD/MM/YYYY" name="dob" v-model="currentDependent.dob"
                            data-vv-as="birth date" data-vv-validate-on="blur" v-mask="'##/##/####'" :disabled="currentDependent.edi !== null"
                            v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('dependent.dob')
                            }">
                        <div v-show="validationErrors.has('dependent.dob')"
                            class="invalid-feedback">
                            {{ validationErrors.first('dependent.dob') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Gender</label>
                        <select :disabled="currentDependent.edi !== null" name="gender" v-model="currentDependent.g"
                            data-vv-as="gender" data-vv-validate-on="blur|input"
                            v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('dependent.gender')
                        }">
                            <option :value="null">Please Select...</option>
                            <option v-for="(gender, index) in genders" :key="index"
                                :value="gender.value">
                                {{gender.text}}
                            </option>
                        </select>
                        <div v-show="validationErrors.has('dependent.gender')" class="invalid-feedback">
                            {{ validationErrors.first('dependent.gender') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Email (Optional)</label>
                        <input type="text" placeholder="Email" name="email" v-model="currentDependent.e"
                            data-vv-as="email" data-vv-validate-on="blur" :disabled="currentDependent.edi !== null"
                            v-validate="'email'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('dependent.email')
                            }">
                        <div v-show="validationErrors.has('dependent.email')"
                            class="invalid-feedback">
                            {{ validationErrors.first('dependent.email') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Phone Number</label>
                        <input type="text" placeholder="Phone Number" name="phoneNumber" v-model="currentDependent.p" :disabled="currentDependent.edi !== null" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>Relationship</label>
                        <select placeholder="Relationship" name="relationship" v-model="currentDependent.r"
                            data-vv-as="relationship" data-vv-validate-on="blur"
                            v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('dependent.relationship')
                            }">
                            <option :value="null" disabled hidden>Please Select...</option>
                            <option v-for="(relationshipType, index) in relationshipTypes.filter(function(element){ return element.value > 0; })" :key="index"
                                :value="relationshipType.value">
                                {{relationshipType.text}}
                            </option>
                        </select>
                        <div v-show="validationErrors.has('dependent.relationship')"
                            class="invalid-feedback">
                            {{ validationErrors.first('dependent.relationship') }}
                        </div>
                    </div>
                </form>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary" @click="saveDependent">Add</button>
                <button type="button" class="btn btn-secondary" @click="dismissDependentPopup">Close</button>
            </template>
        </popup-modal>

        <popup-modal ref="popupModalDeactivationAlert" :hasCloseButton="false" title="Deactivate Employee">
            <template slot="content">
                Are you sure? Please provide deactivation date if you wish to continue.
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary" @click="toggleDeactivationDate">Okay</button>
                <button type="button" class="btn btn-secondary" @click="dismissDeactivationAlert">Close</button>
            </template>
        </popup-modal>

        <popup-modal ref="popupSuccessfullySave" :hasCloseButton="false" title="Employee Details Updated!">
            <template slot="content">
                <p v-html="submitMessage">
                    {{submitMessage}}
                </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary" @click="dismissSuccessfullySavedMessage">Okay</button>
            </template>
        </popup-modal>

        <popup-modal ref="popupModalDeleteAlert" :hasCloseButton="false" title="Delete Employee">
            <template slot="content">
                Are you sure? Deleted employees will have their benefits removed.
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary" @click="deleteEmployee">Confirm</button>
                <button type="button" class="btn btn-secondary" @click="dismissDeleteEmployeeAlert">Close</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import $ from 'jquery';
import 'daterangepicker/daterangepicker';
import {
    convertDateToDDMMYYYY,
    convertDateToIso8601
} from '@/utilities';
import identificationTypes from '@/config/identificationTypes';
import relationshipTypes from '@/config/relationshipTypes';
import genders from '@/config/genders';
import {
    mask
} from 'vue-the-mask';
import popupModal from '@/components/popup-modal';
export default {
    'name': '',
    'components': {
        popupModal
    },
    'directives': {
        mask
    },
    'computed': {
        companyName () {
            return this.$store.state.operator.companyNameDisplay;
        },
        employeeTierId () {
            return this.$route.name === 'employee-tier-detail' ? this.$route.params.id : null;
        },
        isAddEmployeeTier () {
            return this.$route.name === 'employee-tier-detail-add';
        },
        pageTitle () {
            return this.isAddEmployeeTier ? 'Add New Employee' : 'View / Edit Employee Details';
        },
        shouldShowSubmitMessage () {
            return this.submitMessage ? this.submitMessage.length > 0 : false;
        },
        identificationTypeValidation () {
            let minIdentificationType = this.identificationTypes[0].value;
            let maxIdentificationType = this.identificationTypes[this.identificationTypes.length - 1].value;

            return `required|between:${minIdentificationType},${maxIdentificationType}`;
        },
        allowDelete () {
            var iso8601Date = convertDateToIso8601(this.form.dd);
            var ddMMyyyyDate = convertDateToDDMMYYYY(iso8601Date);
            var parts = ddMMyyyyDate.split('/');
            var deactivationDate = new Date(parts[2], parts[1] - 1, parts[0]);
            return deactivationDate < new Date();
        }
    },
    mounted () {
        if (!this.isAddEmployeeTier && this.employeeTierId) {
            this.axios.get('EmployeeTier/GetEmployeeTierDetails', {
                'params': {
                    'employeeTierId': this.employeeTierId
                }
            }).then(({
                data
            }) => {
                let employeeTierData = data.data;
                this.form.eti = employeeTierData.eti;
                this.form.ui = employeeTierData.ui;
                this.form.fn = employeeTierData.fn;
                this.form.it = employeeTierData.it;
                this.form.in = employeeTierData.in;
                this.form.dob = convertDateToDDMMYYYY(employeeTierData.dob);
                this.form.e = employeeTierData.e;
                this.form.pn = employeeTierData.pn;
                this.form.en = employeeTierData.en;
                this.form.d = employeeTierData.d;
                this.form.ti = employeeTierData.ti;
                this.form.tn = employeeTierData.tn;
                this.form.jd = employeeTierData.jd ? convertDateToDDMMYYYY(employeeTierData.jd) : '';
                this.form.dd = employeeTierData.dd ? convertDateToDDMMYYYY(employeeTierData.dd) : '';
                this.form.g = employeeTierData.g ? employeeTierData.g : null;
                this.form.dl = employeeTierData.dl.map((d) => ({
                    'edi': d.edi,
                    'fn': d.fn,
                    'it': d.it,
                    'in': d.in,
                    'dob': d.dob ? convertDateToDDMMYYYY(d.dob) : '',
                    'e': d.e,
                    'p': d.p,
                    'r': d.r,
                    'g': d.g
                }));
                this.showDeactivationDate = employeeTierData.dd != null;
                this.originalJson = JSON.stringify(this.form);
            }).catch(() => {});
            this.showForm = true;
            this.isNewUser = false;
        } else {
            // this.axios.get('EmployeeTier/GetEmployeeList')
            //     .then(({ data }) => {
            //         this.employees = data.data.map((employee) => ({
            //             'UserId': employee.ui,
            //             'FullName': employee.fn,
            //             'NRIC': employee.nric,
            //             'Email': employee.e,
            //             'PhoneNumber': employee.pn,
            //             'dateOfBirth': employee.bd ? convertDateToDDMMYYYY(employee.bd) : '-'
            //         }));
            //     }).catch(() => {});
            this.showForm = false;
            this.isNewUser = false;
        }
        this.axios.get('EmployeeTier/GetTierList')
            .then(({ data }) => {
                this.tiers = data.data.map((tier) => ({
                    'TierId': tier.ti,
                    'TierName': tier.tn,
                    'EmployeeSpendingLimit': tier.esl
                }));
            })
            .catch(() => {});

        this.initializeDatePickers();
    },
    data () {
        return {
            'searchIdentityType': 1,
            'searchIdentityNumber': '',
            'form': {
                'eti': null,
                'ui': null,
                'fn': null,
                'it': null,
                'in': null,
                'dob': null,
                'e': null,
                'pn': null,
                'en': null,
                'd': null,
                'ti': null,
                'tn': null,
                'jd': null,
                'dd': null,
                'g': null,
                'dl': []
            },
            'tiers': [],
            'showDeactivationDate': true,
            'showForm': false,
            'isNewUser': false,
            'isSaving': false,
            'submitMessage': '',
            'submitHasError': false,
            'currentDependent': {
                'index': null,
                'edi': null,
                'fn': null,
                'it': null,
                'in': null,
                'dob': null,
                'e': null,
                'p': null,
                'r': null,
                'g': null
            },
            'originalJson': '',
            'isSaved': false,
            'isDeleted': false,
            identificationTypes,
            relationshipTypes,
            genders
        };
    },
    'methods': {
        validateEmployeeTierForm () {
            return this.$validator.validateAll('employee-tier');
        },
        saveChanges () {
            this.validateEmployeeTierForm().then((isValid) => {
                if (isValid) {
                    let tempData = JSON.parse(JSON.stringify(this.form));
                    tempData.dob = tempData.dob ? convertDateToIso8601(tempData.dob) : null;
                    tempData.jd = tempData.jd ? convertDateToIso8601(tempData.jd) : null;
                    tempData.dd = tempData.dd ? convertDateToIso8601(tempData.dd) : null;
                    tempData.g = tempData.g ? tempData.g : 0;
                    tempData.dl.forEach(function (d) {
                        d.dob = d.dob ? convertDateToIso8601(d.dob) : null;
                        d.g = d.g ? d.g : 0;
                    });
                    // tempData.esl = tempData.esl ? tempData.esl : 0;

                    this.submitHasError = false;
                    this.isSaving = true;
                    this.submitMessage = 'Saving employee tier details...';
                    this.axios.post('EmployeeTier/SaveEmployeeTierDetails', tempData)
                        .then(({ data }) => {
                            this.submitMessage = '';
                            let response = data.data;
                            if (response) {
                                // hasInviteNewDependentOrSpouse
                                // hasInviteNewEmployee
                                // newEmployeeDependentCount
                                // newEmployeeSpouseCount
                                // updatedEmployeeDependentCount
                                // updatedEmployeeSpouseCount

                                if (response.hasInviteNewEmployee && response.hasInviteNewDependentOrSpouse) {
                                    this.submitMessage = 'Thanks! Your new employee and his / her spouse(s) will receive invitation emails from us register new user IDs and passwords.';
                                } else if (response.hasInviteNewEmployee) {
                                    this.submitMessage = 'Thanks! Your employee will receive invitation email from us register new user ID and password.';
                                } else if (response.hasInviteNewDependentOrSpouse) {
                                    this.submitMessage = 'Thanks! Your employee\'s spouse(s) / dependent(s) will receive invitation email(s) from us register new user ID(s) and password(s).';
                                } else if (response.hasEmailAddressAlreadyExistError) {
                                    this.submitMessage = 'Your employee details is updated successfully. However, we are unable to send invitation email to your employee as the email address is already registered with another user. Suggest to use another email address and try again.';
                                }
                            }

                            if (this.submitMessage === '') {
                                this.submitMessage = 'Thanks! Your employee details is updated successfully!';
                            }

                            this.$refs.popupSuccessfullySave.show();
                            this.isSaved = true;
                        }).catch((error) => {
                            this.submitHasError = true;

                            if (error.response && error.response.data) {
                                this.submitMessage = error.response.data.message;
                            } else {
                                this.submitMessage = 'Error saving employee tier details... Please try again.';
                            }
                        }).finally(() => {
                            this.isSaving = false;
                        });
                }
            });
        },
        deleteEmployeeAlert () {
            this.$refs.popupModalDeleteAlert.show();
        },
        dismissDeleteEmployeeAlert () {
            this.$refs.popupModalDeleteAlert.hide();
        },
        deleteEmployee () {
            this.dismissDeleteEmployeeAlert();
            this.submitHasError = false;
            this.isSaving = true;
            this.submitMessage = 'Deleting employee...';
            this.axios.post('EmployeeTier/DeleteEmployeeTier', { 'eti': this.form.eti })
                .then(() => {
                    this.submitMessage = 'Employee Deleted!';
                    this.$refs.popupSuccessfullySave.show();
                    this.isDeleted = true;
                }).catch((error) => {
                    this.submitHasError = true;

                    if (error.response && error.response.data) {
                        this.submitMessage = error.response.data.message;
                    } else {
                        this.submitMessage = 'Error deleting employee... Please try again.';
                    }
                }).finally(() => {
                    this.isSaving = false;
                });
        },
        validateDependentForm () {
            return this.$validator.validateAll('dependent');
        },
        deactivationAlert () {
            this.$refs.popupModalDeactivationAlert.show();
        },
        dismissDeactivationAlert () {
            this.$refs.popupModalDeactivationAlert.hide();
        },
        toggleDeactivationDate () {
            this.showDeactivationDate = true;
            this.dismissDeactivationAlert();
        },
        dependentDetail (index) {
            if (index == null) {
                this.currentDependent.index = null;
                this.currentDependent.edi = null;
                this.currentDependent.fn = null;
                this.currentDependent.it = null;
                this.currentDependent.in = null;
                this.currentDependent.dob = null;
                this.currentDependent.e = null;
                this.currentDependent.p = null;
                this.currentDependent.r = null;
                this.currentDependent.g = null;
            } else {
                this.currentDependent = JSON.parse(JSON.stringify(this.form.dl[index]));
                this.currentDependent.index = index;
            }
            this.validationErrors.remove('dependent.fullName');
            this.validationErrors.remove('dependent.identityType');
            this.validationErrors.remove('dependent.identityNumber');
            this.validationErrors.remove('dependent.dob');
            this.validationErrors.remove('dependent.email');
            this.validationErrors.remove('dependent.relationship');
            this.validationErrors.remove('dependent.gender');
            this.$refs.popupModalDependentDetail.show();
        },
        dismissDependentPopup () {
            this.$refs.popupModalDependentDetail.hide();
        },
        saveDependent () {
            this.validateDependentForm().then((isValid) => {
                if (isValid) {
                    if (this.currentDependent.index == null) {
                        this.form.dl.push(JSON.parse(JSON.stringify(this.currentDependent)));
                    } else {
                        this.form.dl[this.currentDependent.index] = JSON.parse(JSON.stringify(this.currentDependent));
                        this.form.dl.push(); // refresh form in front end
                    }
                    this.dismissDependentPopup();
                }
            });
        },
        removeDependent (index) {
            this.form.dl.splice(index, 1);
        },
        checkDetails () {
            this.axios.post('EmployeeTier/GetUserByNric', {
                'it': this.searchIdentityType,
                'in': this.searchIdentityNumber
            }).then(({ data }) => {
                let employeeTierData = data.data;
                if (employeeTierData != null) {
                    this.form.ui = employeeTierData.ui;
                    this.form.fn = employeeTierData.fn;
                    this.form.it = employeeTierData.it;
                    this.form.in = employeeTierData.in;
                    this.form.dob = convertDateToDDMMYYYY(employeeTierData.dob);
                    this.form.e = employeeTierData.e;
                    this.form.pn = employeeTierData.pn;
                    this.form.g = employeeTierData.g;

                    this.isNewUser = false;
                } else {
                    this.form.it = this.searchIdentityType;
                    this.form.in = this.searchIdentityNumber;

                    this.isNewUser = true;
                }
                this.showForm = true;
            }).catch(() => {});
        },
        dismissSuccessfullySavedMessage () {
            this.$refs.popupSuccessfullySave.hide().then(() => {
                this.$router.push(
                    {
                        'name': 'employee-tier-list'
                    });
            });
        },
        initializeDatePickers () {
            $(this.$refs.employeeDob).daterangepicker({
                'singleDatePicker': true,
                'autoApply': true,
                'locale': {
                    'format': 'DD/MM/YYYY'
                }
            });

            $(this.$refs.employeeDob).on(
                'apply.daterangepicker',
                (ev, picker) => {
                    this.form.dob = picker.startDate.format('DD/MM/YYYY');
                }
            );

            $(this.$refs.dob).daterangepicker({
                'singleDatePicker': true,
                'autoApply': true,
                'locale': {
                    'format': 'DD/MM/YYYY'
                }
            });

            $(this.$refs.dob).on(
                'apply.daterangepicker',
                (ev, picker) => {
                    this.currentDependent.dob = picker.startDate.format('DD/MM/YYYY');
                }
            );
        }
    },
    beforeRouteLeave (to, from, next) {
        var formJson = JSON.stringify(this.form);
        if (this.originalJson !== formJson && !this.isSaved && !this.isDeleted && this.showForm) {
            const answer = window.confirm('Do you really want to leave this page? You have unsaved changes!\nPress "OK" to leave this page without saving your changes, or press "Cancel" to stay on this page.');

            if (answer) {
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    }
};

</script>

<style>

</style>
